export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10808.5c1fa1f1.jpg";